function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#E44D26",
  d: "M19.037 113.876L9.032 1.661h109.936l-10.016 112.198-45.019 12.48z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F16529",
  d: "M64 116.8l36.378-10.086 8.559-95.878H64z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEB",
  d: "M64 52.455H45.788L44.53 38.361H64V24.599H29.489l.33 3.692 3.382 37.927H64zm0 35.743l-.061.017-15.327-4.14-.979-10.975H33.816l1.928 21.609 28.193 7.826.063-.017z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M63.952 52.455v13.763h16.947l-1.597 17.849-15.35 4.143v14.319l28.215-7.82.207-2.325 3.234-36.233.335-3.696h-3.708zm0-27.856v13.762h33.244l.276-3.092.628-6.978.329-3.692z"
});

function SvgHtmllogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    width: 56
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTI4IDEyOCIgd2lkdGg9IjU2cHgiPgoJPHBhdGggZmlsbD0iI0U0NEQyNiIgZD0iTTE5LjAzNyAxMTMuODc2bC0xMC4wMDUtMTEyLjIxNWgxMDkuOTM2bC0xMC4wMTYgMTEyLjE5OC00NS4wMTkgMTIuNDh6Ij4KCTwvcGF0aD4KCTxwYXRoIGZpbGw9IiNGMTY1MjkiIGQ9Ik02NCAxMTYuOGwzNi4zNzgtMTAuMDg2IDguNTU5LTk1Ljg3OGgtNDQuOTM3eiI+Cgk8L3BhdGg+Cgk8cGF0aCBmaWxsPSIjRUJFQkVCIiBkPSJNNjQgNTIuNDU1aC0xOC4yMTJsLTEuMjU4LTE0LjA5NGgxOS40N3YtMTMuNzYyaC0zNC41MTFsLjMzIDMuNjkyIDMuMzgyIDM3LjkyN2gzMC43OTl6TTY0IDg4LjE5OGwtLjA2MS4wMTctMTUuMzI3LTQuMTQtLjk3OS0xMC45NzVoLTEzLjgxN2wxLjkyOCAyMS42MDkgMjguMTkzIDcuODI2LjA2My0uMDE3eiI+Cgk8L3BhdGg+Cgk8cGF0aCBmaWxsPSIjZmZmIiBkPSJNNjMuOTUyIDUyLjQ1NXYxMy43NjNoMTYuOTQ3bC0xLjU5NyAxNy44NDktMTUuMzUgNC4xNDN2MTQuMzE5bDI4LjIxNS03LjgyLjIwNy0yLjMyNSAzLjIzNC0zNi4yMzMuMzM1LTMuNjk2aC0zLjcwOHpNNjMuOTUyIDI0LjU5OXYxMy43NjJoMzMuMjQ0bC4yNzYtMy4wOTIuNjI4LTYuOTc4LjMyOS0zLjY5MnoiPgoJPC9wYXRoPgo8L3N2Zz4K";
export { SvgHtmllogo as ReactComponent };